var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-section"},[_c('div',{staticClass:"error-box"},[_c('img',{attrs:{"src":"/img/error.png"}}),_c('h2',[_vm._v("Page Not Found")]),_c('p',[_vm._v("The page you are looking for might have been removed had its changed or is temporarily unavailable")])])])
}]

export { render, staticRenderFns }